export default __webpack_public_path__ + "static/media/email.0044e6b3.svg";